module.exports = __webpack_public_path__ + "img/red-icon-en(3).d6c26e79.png";